import React, { FC } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { SquareMultiplierEnum } from '../game/Enums';
import Row from './Row';

interface StartModalProps {
    show: boolean;
    closeHandler(): void;
}

const StartModal: FC<StartModalProps> = ({ show, closeHandler, children }) => {

    return (
        <Modal show={show} onHide={closeHandler} backdrop="static">
            <Modal.Header>
                <Modal.Title>How to Play</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Get the highest score possible in five minutes.</p>
                <p>Use higher point letters:
                    <div className="ModalSquareContainer">
                        <Row
                            contents={[
                                {char:'J', pointValue:8, multiplier:SquareMultiplierEnum.Normal, classes:'HeaderSquare'},
                                {char:'X', pointValue:8, multiplier:SquareMultiplierEnum.Normal, classes:'HeaderSquare'},
                                {char:'Z', pointValue:8, multiplier:SquareMultiplierEnum.Normal, classes:'HeaderSquare'}
                            ]}
                            x={0}
                            omd={() => {}}
                            omo={() => {}}
                            omu={() => {}}
                            ote={() => {}}
                        />
                    </div>
                    And score multipliers:
                    <div className="ModalSquareContainer">
                        <Row
                                contents={[
                                    {char:'Double Letter', pointValue:0, multiplier:SquareMultiplierEnum.DoubleLetter, classes:'SquareWithText'},
                                    {char:'Triple Letter', pointValue:0, multiplier:SquareMultiplierEnum.TripleLetter, classes:'SquareWithText'},
                                    {char:'Double Word', pointValue:0, multiplier:SquareMultiplierEnum.DoubleWord, classes:'SquareWithText'},
                                    {char:'Triple Word', pointValue:0, multiplier:SquareMultiplierEnum.TripleWord, classes:'SquareWithText'}
                                ]}
                                x={0}
                                omd={() => {}}
                                omo={() => {}}
                                omu={() => {}}
                                ote={() => {}}
                            />
                    </div>
                    To maximize your score. Good luck!
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={closeHandler}>
                    Start!
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default StartModal;